<template>
  <div class="page flex-col">
    <headerNav :initialSelectedIndex="currentSelectedIndex" @update:selectedIndex="updateSelectedIndex" />

    <div class="content flex-col">
      <div class="box_2 flex-col">
        <div class="block_5 flex-col">
          <div class="text-group_14 flex-col justify-between">
            <span class="text_20">成功案例</span>
            <span class="text_21">success&nbsp;cases</span>
          </div>
          <div class="block_10 flex-row justify-between">
            <div class="block_11 flex-col">
              <div class="image-text_13 flex-col justify-between">
                <div class="group_8 flex-col"></div>
                <div class="text-group_15 flex-col justify-between">
                  <span class="text_22">航运</span>
                  <span class="text_23">社交性质的境外船员派遣平台</span>
                </div>
              </div>
              <div class="group_9 flex-row justify-between">
                <span class="text_24">查看更多</span>
                <img
                    class="thumbnail_1"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng02085523002831c28a44684e48e1f17c6e10b5132b6c0c09f23142fcf81582eb.png"
                />
              </div>
            </div>
            <div class="block_12 flex-col">
              <div class="image-text_14 flex-col justify-between">
                <div class="section_6 flex-col"></div>
                <div class="text-group_16 flex-col justify-between">
                  <span class="text_25">数字监管</span>
                  <span class="text_26">让一切都一目了然，尽在掌握之中</span>
                </div>
              </div>
              <div class="group_10 flex-row justify-between">
                <span class="text_27">查看更多</span>
                <img
                    class="thumbnail_2"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng02085523002831c28a44684e48e1f17c6e10b5132b6c0c09f23142fcf81582eb.png"
                />
              </div>
            </div>
            <div class="block_13 flex-col">
              <div class="image-text_15 flex-col justify-between">
                <div class="group_11 flex-col"></div>
                <span class="text-group_17">轻量级企业AI&nbsp;&nbsp;Agent</span>
              </div>
              <div class="box_13 flex-row justify-between">
                <span class="text_28">查看更多</span>
                <img
                    class="thumbnail_3"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng02085523002831c28a44684e48e1f17c6e10b5132b6c0c09f23142fcf81582eb.png"
                />
              </div>
              <span class="paragraph_1">
                以自研入库算法为核心，打造「安全合规」「高度定制」
                <br />
                的AI智能体
                <br />
              </span>
            </div>
          </div>
        </div>

        <bottomNav />
      </div>
    </div>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav";
import bottomNav from "@/components/bottomNav";

export default {
  components: {
    headerNav,
    bottomNav,
  },
  data() {
    return {
      currentSelectedIndex: 6, // 默认选中“新闻动态”
    }
  },
  methods: {
    updateSelectedIndex(index) {
      this.currentSelectedIndex = index; // 更新选中的索引
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    }
  }, computed: {
    totalPages() {
      return Math.ceil(this.articles.length / this.pageSize);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.articles.slice(start, start + this.pageSize);
    }
  },
}
</script>

<style scoped lang="css" src="./assets/index.css" />
